import { render, staticRenderFns } from "./upgrade-order.vue?vue&type=template&id=6b0e3ed0&scoped=true"
import script from "./upgrade-order.vue?vue&type=script&lang=js"
export * from "./upgrade-order.vue?vue&type=script&lang=js"
import style0 from "./upgrade-order.vue?vue&type=style&index=0&id=6b0e3ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e3ed0",
  null
  
)

export default component.exports